<template>
    <div>
        <template v-if="multiple">
            <el-row type="flex">
                <div>
                    <el-upload
                        :disabled="disabled"
                        :multiple="true"
                        class="avatar-uploader"
                        action=""
                        :show-file-list="false"
                        :before-upload="beforeUpload"
                    >
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </div>
                <vuedraggable v-model="pics" @end="onDragEnd">
                    <el-card class="pic-card" :body-style="{ padding: '0px' }" v-for="item in pics" :key="item.url">
                        <div class="img-wrapper" @mouseover="curImg = item.url" @mouseout="curImg = null">
                            <video controls style="height: 167px" :src="item.url" v-if="isVideo(item.url)"></video>
                            <img style="height: 167px" :src="item.url" v-else alt="" />
                            <el-button
                                class="icon-close"
                                type="text"
                                @click="() => handleDel(item)"
                                v-show="curImg == item.url"
                                icon="el-icon-close"
                            ></el-button>
                        </div>
                    </el-card>
                </vuedraggable>
            </el-row>
            <div v-if="tip" class="tip">{{ tip }}</div>
        </template>
        <template v-else>
            <template v-if="type === 'image'">
                <template v-if="size != 'small'">
                    <el-upload :disabled="disabled" class="avatar-uploader" action="" :show-file-list="false" :before-upload="beforeUpload">
                        <img v-if="pic.url" :src="pic.url" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </template>
                <div v-else class="small">
                    <el-upload :disabled="disabled" class="avatar-uploader" action="" :show-file-list="false" :before-upload="beforeUpload">
                        <img v-if="picSmall.url" :src="picSmall.url" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </div>
            </template>
            <template v-else>
                <video v-if="type === 'video' && pic.url" id="video" style="width: 300px" controls :src="pic.url"></video>
                <el-upload :disabled="disabled" action="" :before-upload="beforeUpload" :show-file-list="false">
                    <el-button v-if="!disabled" size="small" type="primary">
                        <slot></slot>
                    </el-button>
                </el-upload>
            </template>
            <div v-if="tip" class="tip" :style="`margin-top: ${type === 'image' ? '-10px' : '0'}`">
                {{ tip }}
            </div>
        </template>
    </div>
</template>

<script>
import { upload, uploadFile } from "@/api/upload";
import { ossUrl } from "@/configs/oss";
import vuedraggable from "vuedraggable";
export default {
    components: { vuedraggable },
    props: {
        value: {
            type: String | Array,
            default: "",
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        tip: {
            type: String,
            default: "",
        },
        limit: {
            type: Number,
            default: 10,
        },
        type: {
            type: String,
            default: "image",
        },
        size: {
            type: String,
            default: "",
        },
        sizeLimit: {
            type: Number,
            default: 1024 * 1024 * 999999,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        accept: {
            type: String,
            default: "image",
        },
    },
    data() {
        return {
            pics: [],
            curImg: null,
            pic: {
                path: "",
                url: "",
            },
            picSmall: {
                path: "",
                url: "",
            },
            num: 0,
        };
    },
    watch: {
        value: {
            handler(val) {
                if (val) {
                    if (this.multiple) {
                        this.pics = val.map((x) => ({ path: x, url: ossUrl + x }));
                    } else if (this.size == "small") {
                        this.picSmall = { path: val, url: ossUrl + val };
                    } else {
                        this.pic = { path: val, url: ossUrl + val };
                    }
                } else {
                    if (this.multiple) {
                        this.pics = [];
                    } else if (this.size == "small") {
                        this.picSmall = { path: "", url: "" };
                    } else {
                        this.pic = { path: "", url: "" };
                    }
                }
            },
            immediate: true,
        },
    },
    methods: {
        onDragEnd() {
            // 强制更新数组
            this.pics = [...this.pics];
            // 触发父组件的更新
            this.$emit(
                "input",
                this.pics.map((x) => x.path)
            );
            this.$emit("change", this.pics);
        },
        beforeUpload(file) {
            if (file.size > this.sizeLimit) {
                this.$message.warning("文件大小不能超过" + this.sizeLimit / 1024 / 1024 + "M");
                return;
            }
            if (this.multiple) {
                if (this.limit <= this.num) {
                    this.$message.warning("最多上传" + this.limit + "张图片");
                    return false;
                }
                this.num++;
            }
            const [type] = file.type.split("/");
            if (this.type === "image") {
                if (this.accept.indexOf("image") > -1 || this.accept.indexOf("video") > -1) {
                    if (type != "image" && type != "video") {
                        this.$message.warning("请上传图片或视频文件");
                        return false;
                    }
                } else {
                    if (type != "image") {
                        this.$message.warning("请上传图片文件");
                        return false;
                    }
                }
            }
            if (this.type === "video") {
                if (type != "video") {
                    this.$message.warning("请上传视频文件");
                    return false;
                }
            }
            if (type === "video" || this.type === "all") {
                uploadFile({ file }).then(({ code, error, result }) => {
                    if (code === 200) {
                        if (this.multiple) {
                            this.pics.push({ path: result.url, url: ossUrl + result.url, size: file.size, file_name: result.file_name });

                            this.$emit(
                                "input",
                                this.pics.map((x) => x.path)
                            );
                            this.$emit("change", this.pics);
                        } else if (this.size == "small") {
                            this.picSmall = { path: result.url, url: ossUrl + result.url, size: file.size, file_name: result.file_name };
                            this.$emit("input", this.picSmall.path);
                            this.$emit("change", this.picSmall);
                        } else {
                            this.pic = { path: result.url, url: ossUrl + result.url, size: file.size, file_name: result.file_name };
                            this.$emit("input", this.pic.path);
                            this.$emit("change", this.pic);
                        }
                    } else {
                        this.$message.error(error.message);
                    }
                });
            } else {
                upload(file).then(({ code, error, result }) => {
                    if (code === 200) {
                        if (this.multiple) {
                            this.pics.push({ path: result, url: ossUrl + result, size: file.size });
                            this.$emit(
                                "input",
                                this.pics.map((x) => x.path)
                            );
                            this.$emit("change", this.pics);
                        } else if (this.size == "small") {
                            this.picSmall = { path: result, url: ossUrl + result, size: file.size };
                            this.$emit("input", this.picSmall.path);
                            this.$emit("change", this.picSmall);
                        } else {
                            this.pic = { path: result, url: ossUrl + result, size: file.size };
                            this.$emit("input", this.pic.path);
                            this.$emit("change", this.pic);
                        }
                    } else {
                        this.$message.error(error.message);
                    }
                });
            }
            return false;
        },
        handleDel(item) {
            this.pics = this.pics.filter((pic) => pic.url !== item.url);
            this.num--;
            this.$emit(
                "input",
                this.pics.map((x) => x.path)
            );
        },
        isVideo(url) {
            let res = false;
            [
                ".mp4",
                ".MP4",
                ".avi",
                ".AVI",
                ".mov",
                ".MOV",
                ".wmv",
                ".WMV",
                ".mpg",
                ".MPG",
                ".rm",
                ".RM",
                ".rmvb",
                ".RMVB",
                ".flv",
                ".FLV",
                ".mkv",
                ".MKV",
                ".f4v",
                ".F4V",
                ".mpeg",
                ".MPEG",
            ].forEach((x) => {
                if (url.indexOf(x) > -1) {
                    res = true;
                }
            });
            return res;
        },
    },
};
</script>

<style lang="less" scoped>
.tip {
    font-size: 12px;
    color: #999;
    margin-top: -10px;
}

.icon-close {
    color: red;
    position: absolute;
    top: 0;
    right: 0;
    padding: 2px;
    cursor: pointer;
    font-size: 20px;
}

.pic-card {
    display: inline-block;
    position: relative;
    margin-left: 10px;
}

.img-wrapper {
    position: relative;
    display: inline-block;
}
.small {
    .avatar-uploader-icon {
        font-size: 18px;
        width: 50px;
        height: 50px;
        line-height: 50px;
    }

    .avatar {
        width: unset;
        height: 50px;
    }
}
</style>
